import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeletePhysicalDistributionTemplate,
  useGetPhysicalDistributionSectionTemplate,
} from 'services/templates/physical-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const PhysicalDistributionTemplateSection = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const physicalDistribution = useGetPhysicalDistributionSectionTemplate(id);

  const removePhysicalDistribution = useDeletePhysicalDistributionTemplate(id);

  const onRemovePhysicalDistributionTemplate = async (
    actions: PopupActions
  ) => {
    await removePhysicalDistribution.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={
        physicalDistribution.data?.title ??
        t('contract-template.physicalDistribution.title')
      }
      backPath='templates-extended'
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(`/templates-extended/physical-distribution/edit/${id}/form`, {
                replace: true,
              })
            }>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemovePhysicalDistributionTemplate}
            removeLoading={physicalDistribution.isPending}
            name={physicalDistribution.data?.title}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.distribution.initialStatus,
        displayMode: true,
      }}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: physicalDistribution.data
          ? middleware.template.physicalDistribution.queryToForm(
              physicalDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(
              TEMPLATE_TYPE.physicalDistribution
            ),
      }}
      onSubmit={() => {}}
      status={{ isLoading: physicalDistribution.isLoading, displayMode: true }}
    />
  );
};

export default PhysicalDistributionTemplateSection;
